import React from 'react';
import { NavLink } from 'react-router-dom';
import { TopLevelContainer } from '@xo-union/tk-component-grid';

import styles from './styles.scss';

interface Props {
  children: React.ReactNode | React.ReactNode[];
}

export const TabNav: React.FC<Props> = ({ children }) => {
  return (
    <div className={styles.tabContainer}>
      <TopLevelContainer>
        <ul>{children}</ul>
      </TopLevelContainer>
    </div>
  );
};

interface ItemProps {
  to: string;
}

export const TabNavItem: React.FC<ItemProps> = ({ to, children }) => {
  return (
    <li className={styles.tabItem}>
      <NavLink exact to={to} activeClassName={styles.active}>
        {children}
      </NavLink>
    </li>
  );
};
